export const ReactionCodeValue = {
    LIKE: ':like:',
    WOW: ':wow:',
    SAD: ':sad:',
    HAHA: ':haha:',
    ANGRY: ':angry:',
    CLAP: ':clap:',
    THUMBS_UP: ':thumbs_up:',
    THINKING: ':thinking:',
    LOVE: ':love:',
    SMILE: ':smile:',
};
//# sourceMappingURL=constants.js.map